type errorMessageCustomLink = {
  pathname?: string
  redirectTo?: string
  text?: string
}

export type ErrorMessageConfig = {
  errorHeading?: string
  message: string
  showErrorHeading?: boolean
  includeCustomerCare?: boolean
  customLink?: errorMessageCustomLink
}

export const CHECKOUT_ERROR_MESSAGES: Record<string, ErrorMessageConfig> = {
  ERROR_GENERAL: {
    message: 'Unfortunately, there has been an error trying to place Order, please try again later.',
    showErrorHeading: true,
    includeCustomerCare: true,
  },
  ERROR_BASKET_TOTAL: {
    message: `Sorry, something went wrong and we couldn’t complete your order. Don’t worry, no payment was taken. Please try again when you're ready.`
  },
  BONUSCARD_ERROR_GENERAL: {
    message: 'Unfortunately, there has been an error trying to top up your Bonus Card, please try again later.',
    showErrorHeading: true,
    includeCustomerCare: true,
  },
  THREEDSECURE_GENERAL: {
    message: 'We are having trouble placing your order at the moment. Your credit or debit card have not been charged. Please try again later.',
    includeCustomerCare: true,
  },
  PAYMENT_ERROR: {
    message: 'There was a problem with your payment which means your order has NOT been completed. Please check your card details and ensure you have the full funds available in your account.',
  },
  VERIFICATION_FAILED: {
    message: 'Credit Card Verification Failed',
  },
  THREEDSECURE_CANCELLED: {
    message: "You'll need to use 3D Secure to pay for your order. If you can't use 3D Secure then please pay with a different payment method.",
  },
  CVV_ERROR: {
    message: 'Card details are incorrect, please try again.',
  },
  DELIVERY_STORE_ID_VALIDATION_ERROR: {
    message: 'Unfortunately, there has been an error trying to place your order. To process the order, you will need to ', // handled separately in checkout-error-message.tsx
    showErrorHeading: true,
    includeCustomerCare: true,
    customLink: {
      pathname: '/book-delivery',
      redirectTo: '/basket',
      text: 'book a new delivery slot here.' 
    }
  },
  ORDER_PROCESSING_ERROR: {
    message: 'Order processing failed'
  },
  TOKENIZE_ERROR: {
    message: 'Error tokenizing payment'
  },
  PAYPAL_GENERAL_ERROR: {
    message: 'PayPal error'
  },
  PAYPAL_BUTTON_ERROR: {
    message: 'Error creating PayPal button'
  },
  APPLE_PAY_CONTAINER_ERROR: {
    message: 'Apple Pay container(s) not found'
  },
  APPLE_PAY_MERCHANT_ERROR: {
    message: 'Merchant validation failed'
  },
  APPLE_PAY_INITIALIZATION_ERROR: {
    message: 'Error initializing Apple Pay'
  },
  GOOGLE_PAY_INITIALIZATION_ERROR: {
    message: 'Error initializing Google Pay'
  },
  KLARNA_PAY_SDK_ERROR: {
    message: 'Klarna SDK not loaded.'
  },
  KLARNA_PAY_INITIALIZATION_ERROR: {
    message: 'Error initializing Klarna'
  },
  KLARNA_PAY_MISSING_ITEMS: {
    message: 'Product items are missing.'
  },
  KLARNA_PAY_UNABLE_TO_PROCESS: {
    message: 'Sorry, we couldn’t process your payment. Please try a different method. Don’t worry, your order is still safe.'
  }
}
